export default __webpack_public_path__ + "static/media/clicked-bg.f0d8a94a.svg";